// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} MedicineConfiguration
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} medicine
 * @property {string} brandName
 * @property {string} drugType
 * @property {string} beforeFood
 * @property {string} afterFood
 * @property {string} morning
 * @property {string} afternoon
 * @property {string} night
 * @property {number} duration
 * @property {string} durationUnit
 * @property {string} dispense
 * @property {string} dosageSig
 * @property {number} dosageAmount
 * @property {string} frequency
 * @property {number} frequencyReminderInterval
 * @property {string} formulation
 * @property {string} note
 * @property {string} label
 */

/**
 * @typedef {Object} MedicineFormulation
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} medicine
 * @property {string} formulation
 * @property {string} classification
 * @property {string} form
 */

/**
 * @typedef {Object} Medicine
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} genericName
 * @property {string} brandName
 * @property {MedicineFormulation[]} formulations
 */

const state = {
  /** @type {Medicine[]} */
  medicines: [],
  /** @type {MedicineConfiguration[]} */
  favoriteMedicines: []
};

export default state;

/**
 * @param {state} state
 * @returns {Medicine[]}
 */
export function customMedicines (state) {
  return state.medicines.filter(m => m.createdBy);
}

/**
 * @param {state} state
 * @returns {Medicine[]}
 */
export function fixtureMedicines (state) {
  return state.medicines.filter(m => !m.createdBy);
}

/**
 * NOTE: this doesn't belong in the store
 * @param {state} state
 * @returns {any[]}
 */
export function combinedMedicines (state) {
  return [
    { header: 'Favorites' },
    ...state.favoriteMedicines.sort((a, b) => b.createdAt - a.createdAt),
    { header: 'Custom' },
    ...state.medicines
      .filter(m => m.createdBy)
      .sort((a, b) => b.createdAt - a.createdAt),
    { header: 'Default' },
    ...state.medicines
      .filter(m => !m.createdBy)
  ];
}
